import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function SessionExpiredDialog({ open, onSignIn }: { open: boolean; onSignIn: () => void }) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Your session expired</AlertDialogTitle>
          <AlertDialogDescription>Sign in again to continue. You'll come back to this page.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button autoFocus onClick={onSignIn}>
            Sign in
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
